import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { CaptainsInitialState } from '../../types/store/captains'
import type { Captain } from '../../types/fpl/elements'


export const captainsInitialState: CaptainsInitialState = {
  captainsData: null
}

export const captainsSlice = createSlice({
  name: 'captains',
  initialState: captainsInitialState,
  reducers: {
    setCaptainsData: (state, action: PayloadAction<Captain[]>): void => {
      state.captainsData = action.payload
    }
  }
})

export const { setCaptainsData } = captainsSlice.actions
export default captainsSlice.reducer
